import React, { useCallback, useEffect, useState } from 'react';
import { BASE } from '../services/api';
import '../assets/css/MinhaIA.css';

// "Minha IA": o corretor liga a IA dele (Claude, ChatGPT...) ao sistema pelo servidor MCP.
// Fase 1 só leitura. O jeito fácil é o LINK PESSOAL: cola no "conector personalizado" da IA,
// sem configurar nada. O link carrega o token — aparece uma vez (o back guarda só o hash).

const NOME_CONECTOR = '61 Imóveis';

const EXEMPLOS = [
  'Quais apartamentos de 3 quartos no Sudoeste até R$ 1,2 milhão estão disponíveis?',
  'Quanto vale o m² de um apartamento reformado de 100 m² na Asa Norte?',
  'Em quais portais o imóvel 12345 está anunciado e há quantos dias?',
  'Quais captações minhas estão paradas na etapa de interação?',
  'Resuma minhas tarefas críticas e me diga por onde começar.',
  'Como foram minhas últimas visitas? Que notas os clientes deram?',
  'Quais imóveis tiveram mais acessos e contatos no DF Imóveis nos últimos 30 dias?',
];

const VE = ['Imóveis disponíveis e anúncios nos portais', 'Acessos e cliques dos anúncios no DF Imóveis',
  'Análise de mercado (a do Precificador)',
  'Visitas, propostas, captações e tarefas: as suas; gerente, as da equipe; diretoria, as da empresa'];
const NAO_VE = ['Telefone, e-mail e CPF de clientes e proprietários', 'Fichas, assinaturas e áudios de visita',
  'Nada pode ser alterado pela IA'];

const data = (iso) => (iso ? new Date(iso).toLocaleDateString('pt-BR') : '—');

export function configuracoes(link) {
  return [
    { id: 'claude-code', titulo: 'Claude Code (terminal)', texto: `claude mcp add --transport http 61imoveis ${link}` },
    {
      id: 'cursor', titulo: 'Cursor — arquivo ~/.cursor/mcp.json',
      texto: JSON.stringify({ mcpServers: { '61imoveis': { url: link } } }, null, 2),
    },
    {
      id: 'claude-desktop', titulo: 'Claude Desktop — claude_desktop_config.json (precisa do Node)',
      texto: JSON.stringify({ mcpServers: { '61imoveis': { command: 'npx', args: ['-y', 'mcp-remote', link] } } }, null, 2),
    },
  ];
}

function Icone({ d, tamanho = 18 }) {
  return (
    <svg width={tamanho} height={tamanho} viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      {d.split('|').map((p) => <path key={p} d={p} />)}
    </svg>
  );
}
const I = {
  link: 'M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71|M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71',
  copiar: 'M9 9h11v11H9z|M5 15H4V4h11v1',
  ok: 'M20 6 9 17l-5-5',
  escudo: 'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z',
  x: 'M18 6 6 18|M6 6l12 12',
  chat: 'M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z',
  externo: 'M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6|M15 3h6v6|M10 14 21 3',
  celular: 'M7 2h10a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z|M12 18h.01',
};

function Copiar({ texto, rotulo = 'Copiar', classe = 'mia-btn mia-btn--claro', copiado = 'Copiado!', ariaLabel }) {
  const [feito, setFeito] = useState(false);
  async function copiar() {
    try {
      await navigator.clipboard.writeText(texto);
      setFeito(true);
      setTimeout(() => setFeito(false), 1800);
    } catch { /* sem permissão de área de transferência: a pessoa seleciona e copia */ }
  }
  return (
    <button type="button" className={classe} onClick={copiar} disabled={!texto}
      aria-label={ariaLabel} title={ariaLabel}>
      <Icone d={feito ? I.ok : I.copiar} tamanho={15} />{feito ? copiado : rotulo}
    </button>
  );
}

// Miniatura do formulário do conector: o corretor vê onde vai cada coisa.
function TelaConector({ titulo, campos, botao }) {
  return (
    <div className="mia-tela" aria-hidden="true">
      <div className="mia-tela-barra"><i /><i /><i /></div>
      <div className="mia-tela-corpo">
        <strong>{titulo}</strong>
        {campos.map(([rotulo, valor, destaque]) => (
          <div className="mia-tela-campo" key={rotulo}>
            <span>{rotulo}</span>
            <div className={destaque ? 'is-destaque' : ''}>{valor}</div>
          </div>
        ))}
        <em>{botao}</em>
      </div>
    </div>
  );
}

function Passo({ n, children }) {
  return <li className="mia-passo"><span className="mia-passo-n">{n}</span><div>{children}</div></li>;
}

function GuiaClaude() {
  return (
    <div className="mia-guia">
      <ol className="mia-passos">
        <Passo n={1}>
          Abra o <strong>Claude no navegador</strong> (computador ou celular) e entre na sua conta.
          <a className="mia-atalho" href="https://claude.ai/settings/connectors" target="_blank" rel="noreferrer">
            Abrir Conectores do Claude <Icone d={I.externo} tamanho={13} />
          </a>
        </Passo>
        <Passo n={2}>Em <strong>Configurações → Conectores</strong>, clique em <strong>Adicionar conector personalizado</strong>.</Passo>
        <Passo n={3}>
          Em <strong>Nome</strong> escreva <code>{NOME_CONECTOR}</code>. Em <strong>URL</strong> cole <strong>o seu link</strong>.
          Clique em <strong>Adicionar</strong>.
        </Passo>
        <Passo n={4}>
          Numa conversa nova, abra o menu <strong>+</strong> (ferramentas) e confira se <strong>{NOME_CONECTOR}</strong> está ligado.
          Na primeira pergunta, o Claude pede para usar o conector: clique em <strong>Permitir</strong>.
        </Passo>
      </ol>
      <TelaConector titulo="Adicionar conector personalizado" botao="Adicionar"
        campos={[['Nome', NOME_CONECTOR], ['URL do servidor MCP remoto', 'cole seu link aqui', true]]} />
      <p className="mia-dica"><Icone d={I.celular} tamanho={15} />Adicionou no site? Ele aparece sozinho no <strong>app do Claude</strong> no celular.</p>
      <p className="mia-dica mia-dica--leve">Não achou a opção? Ela depende do plano do Claude. Os nomes dos menus podem mudar um pouco.</p>
    </div>
  );
}

function GuiaChatGPT() {
  return (
    <div className="mia-guia">
      <ol className="mia-passos">
        <Passo n={1}>
          Abra o <strong>ChatGPT no computador</strong> e vá em <strong>Configurações → Apps e conectores</strong>.
          <a className="mia-atalho" href="https://chatgpt.com/#settings/Connectors" target="_blank" rel="noreferrer">
            Abrir o ChatGPT <Icone d={I.externo} tamanho={13} />
          </a>
        </Passo>
        <Passo n={2}>Em <strong>Configurações avançadas</strong>, ligue o <strong>Modo desenvolvedor</strong>.</Passo>
        <Passo n={3}>
          Clique em <strong>Criar</strong>. Nome: <code>{NOME_CONECTOR}</code>. URL do servidor MCP: <strong>o seu link</strong>.
          Autenticação: <strong>Sem autenticação</strong>. Marque que confia no aplicativo e clique em <strong>Criar</strong>.
        </Passo>
        <Passo n={4}>Na conversa, clique em <strong>+</strong> → <strong>Modo desenvolvedor</strong> e ligue o <strong>{NOME_CONECTOR}</strong>.</Passo>
      </ol>
      <TelaConector titulo="Novo conector" botao="Criar"
        campos={[['Nome', NOME_CONECTOR], ['URL do servidor MCP', 'cole seu link aqui', true], ['Autenticação', 'Sem autenticação']]} />
      <p className="mia-dica mia-dica--leve">No ChatGPT, conector próprio exige plano pago (Plus, Pro ou empresarial). Os nomes dos menus podem mudar um pouco.</p>
    </div>
  );
}

function GuiaOutras({ link }) {
  return (
    <div className="mia-guia mia-guia--uma">
      <p className="mia-dica mia-dica--leve">Para quem usa IA no computador com arquivo de configuração. Na dúvida, use Claude ou ChatGPT.</p>
      {configuracoes(link || '<seu link>').map((c) => (
        <div className="mia-codigo" key={c.id}>
          <div className="mia-codigo-topo"><strong>{c.titulo}</strong>{link && <Copiar texto={c.texto} />}</div>
          <pre>{c.texto}</pre>
        </div>
      ))}
    </div>
  );
}

const ABAS = [['claude', 'Claude'], ['chatgpt', 'ChatGPT'], ['outras', 'Outras IAs']];

export default function MinhaIA() {
  const [estado, setEstado] = useState(null);
  const [erro, setErro] = useState('');
  const [nome, setNome] = useState('');
  const [gerando, setGerando] = useState(false);
  const [novo, setNovo] = useState(null);
  const [aba, setAba] = useState('claude');

  const carregar = useCallback(async () => {
    try {
      const r = await fetch(`${BASE}/mcp/tokens`);
      const d = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(d.error || 'Não foi possível carregar seus links.');
      setEstado(d);
    } catch (e) { setErro(e.message); }
  }, []);

  useEffect(() => { carregar(); }, [carregar]);

  async function gerar(e) {
    e.preventDefault();
    setGerando(true); setErro('');
    try {
      const r = await fetch(`${BASE}/mcp/tokens`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ nome: nome.trim() || 'Minha IA' }),
      });
      const d = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(d.error || 'Não foi possível gerar o link.');
      setNovo({ token: d.token, link: d.link, nome: d.item?.nome });
      setNome('');
      carregar();
    } catch (e2) { setErro(e2.message); } finally { setGerando(false); }
  }

  async function revogar(item) {
    if (!window.confirm(`Desligar "${item.nome}"? A IA que usa este link para de funcionar na hora.`)) return;
    const r = await fetch(`${BASE}/mcp/tokens/${item.id}`, { method: 'DELETE' });
    if (!r.ok) { setErro('Não foi possível desligar.'); return; }
    if (novo && item.prefixo && novo.token.startsWith(item.prefixo)) setNovo(null);
    carregar();
  }

  const bloqueado = estado && (!estado.liberado || !estado.ativo);
  const link = novo?.link;

  return (
    <div className="mia">
      <header className="mia-hero">
        <div className="mia-hero-texto">
          <span className="mia-eyebrow"><i />Minha IA</span>
          <h1>Converse com o sistema da 61 pela sua IA</h1>
          <p>
            Ligue o Claude ou o ChatGPT ao sistema em 2 minutos. Depois é só perguntar: imóveis disponíveis,
            anúncios, preço de mercado, suas visitas, captações e tarefas.
          </p>
          <ol className="mia-trilha" aria-label="Como funciona">
            <li className={link ? 'is-feito' : 'is-atual'}><b>1</b>Gere seu link</li>
            <li className={link ? 'is-atual' : ''}><b>2</b>Cole na sua IA</li>
            <li><b>3</b>Pergunte</li>
          </ol>
        </div>
        <div className="mia-hero-chat" aria-hidden="true">
          <div className="mia-bolha mia-bolha--eu">Quais aptos de 3 quartos no Sudoeste até R$ 1,2 mi estão disponíveis?</div>
          <div className="mia-bolha mia-bolha--ia">
            <small><Icone d={I.link} tamanho={12} /> usando {NOME_CONECTOR}</small>
            Encontrei 8 imóveis. O mais recente é o 12.4xx: 98 m², 2 vagas, R$ 1,15 mi — R$ 11,7 mil/m²,
            dentro da faixa de mercado do bairro.
          </div>
        </div>
      </header>

      {erro && <div className="mia-alerta mia-alerta--erro" role="alert">{erro}</div>}
      {bloqueado && (
        <div className="mia-alerta">
          {!estado.ativo ? 'A IA pessoal está desligada temporariamente.'
            : 'A IA pessoal está em piloto e ainda não foi liberada para você. Fale com a Inteligência.'}
        </div>
      )}

      <section className="mia-card" aria-labelledby="mia-p1">
        <div className="mia-card-topo">
          <span className="mia-num">1</span>
          <div><h2 id="mia-p1">Gere seu link pessoal</h2><p>Um link por IA ou aparelho. Ele vale 180 dias e você pode desligar quando quiser.</p></div>
        </div>

        {link ? (
          <div className="mia-link">
            <div className="mia-link-caixa">
              <Icone d={I.link} />
              <code>{link}</code>
            </div>
            <Copiar texto={link} rotulo="Copiar link" copiado="Link copiado!" classe="mia-btn mia-btn--forte" />
            <p className="mia-link-aviso">
              <Icone d={I.escudo} tamanho={15} />
              <span>Este link é <strong>como uma senha</strong>: não mande para ninguém. Ele aparece <strong>só agora</strong> —
                se perder, gere outro e desligue o antigo.</span>
            </p>
          </div>
        ) : !bloqueado && (
          <form className="mia-gerar" onSubmit={gerar}>
            <label htmlFor="mia-nome">Nome do link</label>
            <div className="mia-gerar-linha">
              <input id="mia-nome" value={nome} maxLength={80} placeholder="Ex.: Claude do celular"
                onChange={(e) => setNome(e.target.value)} />
              <button type="submit" className="mia-btn mia-btn--forte" disabled={gerando || !estado}>
                {gerando ? 'Gerando…' : 'Gerar link'}
              </button>
            </div>
          </form>
        )}
      </section>

      <section className="mia-card" aria-labelledby="mia-p2">
        <div className="mia-card-topo">
          <span className="mia-num">2</span>
          <div><h2 id="mia-p2">Cole o link na sua IA</h2><p>Escolha a IA que você usa e siga os passos.</p></div>
        </div>
        <div className="mia-abas" role="tablist">
          {ABAS.map(([id, rotulo]) => (
            <button key={id} type="button" role="tab" aria-selected={aba === id}
              className={aba === id ? 'is-ativa' : ''} onClick={() => setAba(id)}>{rotulo}</button>
          ))}
        </div>
        {!link && <p className="mia-falta">Gere o link no passo 1 — é ele que você vai colar.</p>}
        {aba === 'claude' && <GuiaClaude />}
        {aba === 'chatgpt' && <GuiaChatGPT />}
        {aba === 'outras' && <GuiaOutras link={link} />}
      </section>

      <section className="mia-card" aria-labelledby="mia-p3">
        <div className="mia-card-topo">
          <span className="mia-num">3</span>
          <div><h2 id="mia-p3">Pergunte do seu jeito</h2><p>Comece com "Use a {NOME_CONECTOR}…" nas primeiras vezes. Alguns exemplos:</p></div>
        </div>
        <ul className="mia-exemplos">
          {EXEMPLOS.map((e) => (
            <li key={e}>
              <Icone d={I.chat} tamanho={16} />
              <span>{e}</span>
              <Copiar texto={e} rotulo="" copiado="" classe="mia-icone-btn" ariaLabel="Copiar pergunta" />
            </li>
          ))}
        </ul>
      </section>

      <div className="mia-duas">
        <section className="mia-card mia-privacidade" aria-labelledby="mia-priv">
          <h2 id="mia-priv"><Icone d={I.escudo} />O que a IA enxerga</h2>
          <ul className="mia-ve">{VE.map((t) => <li key={t}><Icone d={I.ok} tamanho={15} />{t}</li>)}</ul>
          <ul className="mia-ve mia-ve--nao">{NAO_VE.map((t) => <li key={t}><Icone d={I.x} tamanho={15} />{t}</li>)}</ul>
          <p>Mesmo assim, o que a IA lê vai para a empresa dela: não cole dados de clientes na conversa. Cada consulta fica registrada.</p>
        </section>

        <section className="mia-card" aria-labelledby="mia-lista">
          <h2 id="mia-lista">Seus links ativos</h2>
          {!estado ? <p className="mia-vazio">Carregando…</p>
            : !estado.itens.length ? <p className="mia-vazio">Nenhum link ativo ainda.</p>
              : (
                <ul className="mia-tokens">
                  {estado.itens.map((t) => (
                    <li key={t.id}>
                      <div>
                        <strong>{t.nome}</strong>
                        <small>criado {data(t.criado_em)} · último uso {data(t.ultimo_uso_em)} · vence {data(t.expira_em)}</small>
                      </div>
                      <button type="button" className="mia-btn mia-btn--perigo" onClick={() => revogar(t)}>Desligar</button>
                    </li>
                  ))}
                </ul>
              )}
        </section>
      </div>
    </div>
  );
}
